export const mapToJobGroups = queryList =>
  queryList.map(group => ({
    id: group.id,
    description: group.description,
  }));
